import {
    Page,
    Stack,
    Banner,
    ResourceItem,
    Layout,
    Card,
    TextStyle,
    PageActions,
    SkeletonBodyText,
} from '@shopify/polaris';
import { apiFetch as fetch } from '../../common/Helpers';
import moment from 'moment';
import React, { Component } from 'react'
import { Helmet } from 'react-helmet';
import { GenieTag } from '../../components/GenieTag';
import ShowTagGroupErrorsModal from '../../components/ShowTagGroupErrorsModal';

class TagGroupViewPage extends Component {

    constructor(props) {
        super(props)

        const { params } = this.props.match;

        this.state = {
            isLoading: true,
            showingErrors: false,
            creatingRule: false,
            group: null,
            errors: [],
            id: params.id,
            renaming: false,
            newName: null
        };
    }

    render() {

        if (this.state.isLoading)
            return <SkeletonBodyText lines="20" />;

        var hasErrors = this.state.errors.length > 0;

        return (
            <div>
                <Helmet>
                    <title>Tag Genie - Tag Group</title>
                </Helmet>
                <Page
                    title={"Tag Group: " + this.state.group.name}
                    secondaryActions={[{ content: 'Edit', onAction: this.handleEdit }]}
                    breadcrumbs={[{ content: 'Tag Groups', url: '/tag-groups' }]}
                >
                    <Layout fullWidth>
                        <ShowTagGroupErrorsModal
                            active={this.state.showingErrors}
                            errors={this.state.errors}
                            onDismiss={this.toggleErrorsModal} />
                        {hasErrors && <Layout.Section>
                            <Banner
                                title="Validation rule errors"
                                status="critical"
                                onDismiss={null}
                                action={{ content: "Show errors", onAction: this.showErrors }}
                            >
                                <p>This group has resources failing its validation rules. Click to see which resources are failing and why.</p>
                            </Banner>
                        </Layout.Section>}
                        <Layout.Section>
                            <Card>
                                <Card.Section title="Resource Type">
                                    {this.state.group.resourceType}
                                </Card.Section>
                                <Card.Section title="Tags">
                                    <Stack>
                                        {this.state.group.tags.map(item => <GenieTag backgroundColor={this.state.group.color}>{item}</GenieTag>)}
                                    </Stack>
                                </Card.Section>
                            </Card>
                        </Layout.Section>
                    </Layout>
                    <PageActions
                        secondaryActions={[
                            {
                                content: 'Delete group',
                                onAction: this.handleDelete,
                                destructive: true,
                            },
                        ]}
                    />
                </Page>
            </div>
        );
    }

    handleDelete = () => {

        fetch(`api/tagGroups/${this.state.id}`, {
            method: 'DELETE'
        }).then(() => {
            this.props.history.push("/tag-groups");
        });
    }

    handleEdit = () => {

        this.props.history.push(`/tag-groups/edit/${this.state.group.id}`);
    }

    showErrors = () => {
        this.toggleErrorsModal();
    }

    toggleErrorsModal = () => {
        this.setState({
            showingErrors: !this.state.showingErrors
        });
    }

    renderItem = (item) => {
        const { id, name, tags, color } = item;

        return (
            <ResourceItem id={id} url={null} onClick={(e) => { this.handleViewItem(e, item); }}>
                <div>
                    <div className="operationItemContent">
                        <div className="operationItemContentColumn">
                            <TextStyle variation="strong">Tag Group: {name}</TextStyle>
                        </div>
                    </div>
                    <br />
                    <Stack>
                        {tags.map(item => <GenieTag backgroundColor={color}>{item}</GenieTag>)}
                    </Stack>
                </div>
            </ResourceItem>
        );

    }

    parseDate(stringDate) {
        var momentDate = moment(stringDate);
        return momentDate.toDate();
    }

    handleCreate() {
        this.props.history.push("/tag-groups/new");
    }

    handleViewItem = (e, item) => {
        this.props.history.push(`/tag-groups/${item.id}`);
    }

    fetchGroupData = () => {
        fetch(`api/tagGroups/${this.state.id}`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => this.setState({
                group: data,
                isLoading: false
            }));
    }

    fetchErrorsData = () => {
        fetch(`api/tagGroups/${this.state.id}/errors`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => this.setState({
                errors: data,
            }));
    }

    componentDidMount() {
        this.fetchGroupData();
        this.fetchErrorsData();
    }
}

export default TagGroupViewPage